export default __webpack_public_path__ + "static/media/ape-sdk.d42128a4.jpg";